export const SORT_OPTIONS = [
  {
    label: 'All',
    sort_by: 'created_at',
    sort_order: 'ask',
  },
  {
    label: 'Market Cap desc',
    sort_by: 'market_cap',
    sort_order: 'desc',
  },
  {
    label: 'Market Cap asc',
    sort_by: 'market_cap',
    sort_order: 'ask',
  },
  {
    label: 'Created At desc',
    sort_by: 'created_at',
    sort_order: 'desc',
  },
  {
    label: 'Created At asc',
    sort_by: 'created_at',
    sort_order: 'ask',
  },
];
